export default "Comparateur énergie agricole — Électricité & gaz pour exploitations | Solution Éco France";
